<template>
  <div class="hom-page">
    <Header />
    <div class="home-content">
      <div class="lunbo">
        <el-image style="width:100%" src="img/service-quality.jpg" fit="contain"></el-image>
      </div>

      <div class="wrap">
        <div class="header">
          <div class="header-left"><span v-if="language === 'ch'">关于我们</span><span v-else>About US</span></div>
          <div class="header-right"> <span v-if="language === 'ch'">首页 > 关于我们 > 品控</span><span v-else>Home > About Us > Quality Control</span> </div>
        </div>
        <div class="conten-wrap">

          <div class="left">
            <router-link to="/service">
              <div class="left-item"><i class="el-icon-caret-right"> </i><span v-if="language === 'ch'">业务团队</span><span v-else>Business Team</span></div>
            </router-link>
            <router-link to="/serviceOrder">
              <div class="left-item"><i class="el-icon-caret-right"> </i><span v-if="language === 'ch'">订单流程</span><span v-else>Orders Process</span></div>
            </router-link>
            <router-link to="/serviceQuality">
              <div class="left-item"><i class="el-icon-caret-right"> </i><span v-if="language === 'ch'">品控</span><span v-else>Quality Control</span></div>
            </router-link>
          </div>
          <div class="right">
            <el-image src="img/service-quality-description.jpg" fit="fill"></el-image>
          </div>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Header from '../../components/header.vue'
import Footer from '../../components/footer.vue'
export default {
  components: {
    Header,
    Footer
  },
  data() {
    return {
      language: ''
    }
  },
  methods: {},
  created() { },
  mounted() {
    this.language = localStorage.getItem('curlanguage')
  }
}
</script>

<style scoped>
.hom-page {
  height: 100%;
  widows: 100%;
}
a {
  text-decoration: none;
}
.home-content {
  width: 1130px;
  margin: 0 auto;
  height: 1180px;
}
.lunbo {
  margin: 12px 0;
}
.wrap {
  display: flex;
  flex-direction: column;
  height: 100%;
}
.header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  line-height: 48px;
}
.header-left {
  border-bottom: 1px solid #cccccc;
  width: 25%;
}
.header-right {
  border-bottom: 1px solid #cccccc;
  width: 70%;
  color: #cccccc;
  display: flex;
  justify-content: flex-end;
  float: right;
  font-size: 14px;
}
.conten-wrap {
  margin-top: 24px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.left {
  line-height: 30px;
}
.left-item {
  cursor: pointer;
}
.left-item:hover {
  color: blue;
}
</style>

